import { render, staticRenderFns } from "./ChatbotPeriodCountChart.vue?vue&type=template&id=70a72fe0"
import script from "./ChatbotPeriodCountChart.vue?vue&type=script&lang=js"
export * from "./ChatbotPeriodCountChart.vue?vue&type=script&lang=js"
import style0 from "./ChatbotPeriodCountChart.vue?vue&type=style&index=0&id=70a72fe0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports